export type TipoEvento = 'Route' | 'Click' | 'Input' | 'Focus' | 'Blur' | 'KeyDown' | 'Error';
export class LogModel {
    // Identificación / correlación
  SesionId!: string;               // id de sesión (p. ej. uuid)
  CorrelationId?: string;          // para agrupar eventos de una misma acción
  UsuarioId?: string | number;     // si lo tienes

  // Contexto de navegación
  Pantalla!: string;               // ruta/feature (mantengo tu campo)
  Url!: string;                    // location.href actual
  Referrer?: string;               // document.referrer
  FechaHoraUtc!: string;           // new Date().toISOString()
  ZonaHoraria!: string;            // Intl.DateTimeFormat().resolvedOptions().timeZone
  Component: string;

  // Evento
  TipoEvento!: TipoEvento;
  Accion?: string;                 // descripción libre de la acción ("click botón guardar", etc.)
  Click?: string;                  // (compat) si ya lo usabas, puedes poner aquí el target
  Tecla?: string;                  // p.ej. 'Escape', 'Enter' (no guardes texto tecleado)
  EsInteraccionUsuario!: boolean;  // true si viene de interacción real
  EsError?: boolean;

  // Elemento objetivo
  Tag?: string;                    // 'input','button',...
  Id?: string;
  Clases?: string[];
  Name?: string;
  FormControlName?: string;
  Placeholder?: string;
  Label?: string;                  // texto de label asociado
  Selector?: string;               // selector/cssPath aproximado para ubicarlo después

  // Coordenadas del evento (si aplica)
  X?: number;
  Y?: number;
  
  // Identificación del campo / control
  Campo?: string;             // formControlName o name/id
  TipoControl?: string;       // 'input','textarea','select','checkbox','radio','contenteditable','file'

  // Cambio de valor
  ValorAnterior?: any;
  ValorNuevo?: any;
  OpcionTexto?: string | string[]; // select: texto(s) visible(s)
  Checked?: boolean;               // checkbox/radio
  Enmascarado?: boolean;           // si el valor mostrado fue enmascarado
  MascaraEstrategia?: string;      // 'password','pattern','none', etc.

  // Dispositivo/cliente
  UserAgent!: string;
  ViewportAncho!: number;
  ViewportAlto!: number;

  // Rellenados por el backend (desde la request)
  Ip?: string;                     // ⚠️ desde front no es fiable; lo pondrá el backend
  Localizacion?: string;           // idem (GeoIP en server)

  SinCambio?: boolean;      // true si el usuario salió sin modificar el valor
  Commit?: 'blur' | 'change' | 'leave'; // razón del commit

  // Extensión futura
  DatosExtra?: Record<string, unknown>;
}
